import {PaymentsRepository} from '../repository/PaymentsRepository';
import {PaymentStatistics} from '../models/Payment';

export class GetPaymentStatisticsUseCase {
  constructor (private paymentsRepository: PaymentsRepository) {}

  async execute (): Promise<PaymentStatistics> {
    return this.paymentsRepository.getStatistics();
  }
}
